import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import Swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService } from "app/auth/service";
import { Router, ActivatedRoute } from "@angular/router";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesService } from 'app/_services/sales.service';

@Component({
  selector: 'app-sales',
  templateUrl: './sales.component.html',
  styleUrls: ['./sales.component.scss']
})
export class SalesComponent implements OnInit {
  public salesList: any = [];
  public salesListtotal: any = [];
  public start: any = 0;
  public page: any = 0;

  public pageBasicText = 1;
  public collectionSize = 0;
  public lengths = 15;
  public loading = false;
  public progressMainTable: boolean = false;
  public isModelLoading: Boolean = true;
  public salesDetails: any;
  public cust_name: any;

  public newFormAdd: FormGroup;
  public submitted = false;
  public customerDropDown: any = [];
  public productDropDown: any = [];
  public currentUser: any;
  public tempUser: any;
  public user_id: any = 0;
  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private salesService: SalesService,
    private _authenticationService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private _toastrService: ToastrService,
    private http: HttpClient,
    private modalService: NgbModal,
    private _coreSidebarService: CoreSidebarService
  ) { }

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.tempUser = JSON.parse(localStorage.getItem('tempUser'));
    if (this.currentUser.user.id != this.tempUser) {
      this.user_id = this.tempUser;
    } else {
      this.user_id = this.currentUser.user.id;
    }
    this.getcustomerDropDown(this.user_id);
    this.getproductDropDown(this.user_id);

    this.salessList(this.start, this.lengths, this.user_id);

    this.newFormAdd = this._formBuilder.group({
      customer_id: [null],
      product_id: [null],
      start_date: [''],
      end_date: ['']
    });
  }

  get f() {
    return this.newFormAdd.controls;
  }

  getcustomerDropDown(my_user_id: any) {
    this.salesService.getcustomerDropDown(my_user_id).subscribe(
      data => {
        if (data.status) {
          this.customerDropDown = data.customer;
        }
      });
  }
  getproductDropDown(my_user_id: any) {
    this.salesService.getproductDropDown(my_user_id).subscribe(
      data => {
        if (data.status) {
          this.productDropDown = data.product;
        }
      });
  }
  salessList(my_start: any, my_lengths: any, my_user_id: any) {
    const formdata = new FormData();
    formdata.append('start', my_start);
    formdata.append('length', my_lengths);
    formdata.append('user_id', my_user_id);

    this.salesService.getData(formdata).subscribe(
      (response) => {
        this.loading = false;
        this.progressMainTable = false;
        if (response.status) {
          this.salesList = response.data;
          this.salesListtotal = response.total;
          this.collectionSize = response.recordsTotal;
        }
      },
      (err) => {
        if (err.error.error == "Unauthenticated.") {
          this._authenticationService.logout();
          this._router.navigate(["/login"]);
        }
      }
    );
  }

  salessListNew(my_start: any, my_lengths: any, type: any = 0) {
    const formdata = new FormData();
    formdata.append('user_id', this.user_id);
    if (type != 1) {
      formdata.append('start', my_start);
    }
    else {
      formdata.append('start', '0');
      this.page = 0;
      this.pageBasicText = 1;
    }
    formdata.append('length', my_lengths);
    if (type != 1) {
      if (this.f.start_date.value !== null) {
        formdata.append('start_date', this.f.start_date.value);
      }
      if (this.f.end_date.value !== null) {
        formdata.append('end_date', this.f.end_date.value);
      }
      if (this.f.customer_id.value !== null) {
        formdata.append('customer_id', this.f.customer_id.value);
      }
      if (this.f.product_id.value !== null) {
        formdata.append('product_id', this.f.product_id.value);
      }
    }

    this.salesService.getData(formdata).subscribe(
      (response) => {
        this.loading = false;
        this.progressMainTable = false;
        if (response.status) {
          this.salesList = response.data;
          this.salesListtotal = response.total;
          this.collectionSize = response.recordsTotal;
        }
      },
      (err) => {
        if (err.error.error == "Unauthenticated.") {
          this._authenticationService.logout();
          this._router.navigate(["/login"]);
        }
      }
    );
  }
  reloadList(type: any = 0) {
    this.progressMainTable = true;
    this.salessListNew(this.page, this.lengths, type);
  }

  loadPage(event: any) {
    this.progressMainTable = true;
    this.page = this.lengths * (event - 1);
    this.salessListNew(this.page, this.lengths);
  }
  loadPageLenghs(event: any) {
    this.progressMainTable = true;
    this.lengths = event.target.value;
    this.salessListNew(this.start, this.lengths);
  }

  details(sales_data: any, modalSM) {
    this.modalService.open(modalSM, {
      centered: true,
      size: 'xl'
    });
    this.cust_name = sales_data.customer_name;
    this.salesService.getmeta(sales_data.id).subscribe(
      data => {
        this.isModelLoading = false;
        if (data.status) {
          this.salesDetails = data.data;
        } else {
          this._toastrService.error(data.errorMessage, 'Error!');
        }
      },
      err => {
        this._toastrService.error(err.errorMessage, 'Opps!');
      }
    );
  }

  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  onSubmit() {
    this.submitted = true;
    this.loading = true;
    // this.toggleSidebar('new-sidebar');
    this.salesList = [];
    this.salesListtotal = [];
    // stop here if form is invalid
    if (this.newFormAdd.invalid) {

    }
    else {
      this.page = 0;
      this.pageBasicText = 1;

      const formdata = new FormData();
      formdata.append('start', "0");
      formdata.append('length', "15");
      formdata.append('user_id', this.user_id);

      if (this.f.start_date.value !== null) {
        formdata.append('start_date', this.f.start_date.value);
      }
      if (this.f.end_date.value !== null) {
        formdata.append('end_date', this.f.end_date.value);
      }
      if (this.f.customer_id.value !== null) {
        formdata.append('customer_id', this.f.customer_id.value);
      }
      if (this.f.product_id.value !== null) {
        formdata.append('product_id', this.f.product_id.value);
      }
      this.salesService.getData(formdata).subscribe(
        data => {
          this.loading = false;
          if (data.status) {
            this.salesList = data.data;
            this.salesListtotal = data.total;
            this.collectionSize = data.recordsTotal;
          }
        },
        err => {
          if (err.error.error == 'Unauthenticated.') {
            this._authenticationService.logout();
            this._router.navigate(['/login']);
          }
        }
      );
    }
  }

  downloadExcelData() {
    const formdata = new FormData();

    if (this.f.start_date.value !== null) {
      formdata.append('start_date', this.f.start_date.value);
    }
    if (this.f.end_date.value !== null) {
      formdata.append('end_date', this.f.end_date.value);
    }
    if (this.f.customer_id.value !== null) {
      formdata.append('customer_id', this.f.customer_id.value);
    }
    if (this.f.product_id.value !== null) {
      formdata.append('product_id', this.f.product_id.value);
    }
    formdata.append('user_id', this.user_id);
    this.salesService.fileDownload(formdata).subscribe(
      (data) => {
        window.location.href = data.url;
      },
      (error) => {
        this._toastrService.error('Something went wrong! Please Try Againg...', 'Opps!', { toastClass: 'toast ngx-toastr', closeButton: true });
      }
    );
  }
  resetReport() {
    this.newFormAdd.reset();
    this.onSubmit();
  }
  getSum(index: any): number {
    let sum = 0;
    for (let i = 0; i < this.salesList.length; i++) {
      sum += parseFloat(this.salesList[i][index]);
    }
    return sum;
  }
}
